import { render } from "./informForm.vue?vue&type=template&id=70a4a9c6"
import script from "./informForm.vue?vue&type=script&lang=js"
export * from "./informForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__